"use client"

interface ProgressMilestone {
  id: number
  label: string
  icon: string
  completed: boolean
  current: boolean
}

interface CourseProgressJourneyProps {
  milestones: ProgressMilestone[]
}

export function CourseProgressJourney({ milestones }: CourseProgressJourneyProps) {
  const completedCount = milestones.filter((m) => m.completed).length
  const progressPercentage = (completedCount / milestones.length) * 100

  return (
    <div className="bg-slate-100 p-6 rounded-2xl space-y-4">
      <div className="flex items-center gap-4">
        <div className="p-3 bg-teal-100 rounded-full">
          <span className="material-symbols-outlined text-teal-600"></span>
        </div>
        <h2 className="text-2xl font-bold text-slate-900">Your Progress Journey</h2>
      </div>

      <div className="relative py-8">
        {/* Progress bar background */}
        <div className="absolute top-1/2 left-0 right-0 h-1 bg-slate-200 -translate-y-1/2 z-0"></div>
        {/* Progress bar fill */}
        <div
          className="absolute top-1/2 left-0 h-1 bg-gradient-to-r from-teal-500 to-blue-500 -translate-y-1/2 z-0 rounded-full transition-all duration-500"
          style={{ width: `${progressPercentage}%` }}
        ></div>

        {/* Milestones */}
        <div className="relative flex justify-between items-center z-10">
          {milestones.map((milestone) => (
            <div key={milestone.id} className="flex flex-col items-center">
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center ring-4 transition-colors ${
                  milestone.completed || milestone.current
                    ? "bg-teal-500 ring-white"
                    : "bg-slate-300 ring-white opacity-50"
                }`}
              >
                <span
                  className={`material-symbols-outlined text-base ${
                    milestone.completed || milestone.current ? "text-white" : "text-slate-600"
                  }`}
                >
                  {milestone.icon}
                </span>
              </div>
              <p className={`text-xs font-semibold mt-2 text-center ${
                milestone.current ? "text-blue-600" : "text-slate-900"
              }`}>
                {milestone.label}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Progress Stats */}
      <div className="flex items-center justify-between text-sm">
        <span className="text-slate-900 font-medium">
          {completedCount} of {milestones.length} milestones completed
        </span>
        <span className="text-slate-900 font-semibold">
          {Math.round(progressPercentage)}%
        </span>
      </div>
    </div>
  )
}